<template>
    <div>
        Error: not found template
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>